import { FormikInsurance } from "src/types";
import { useLegalContractorSummary } from "./legal-contractor-summary.hook";

export const LegalContractorSummary = ({
  insurance,
}: {
  insurance: FormikInsurance;
}) => {
  const { legalContractor, companyTypeLabel, t } = useLegalContractorSummary({
    insurance,
  });

  return (
    <div className="col-12">
      <div>
        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_company_name")}
            </div>
            <div className="font-16">{legalContractor.companyName}</div>
          </div>
          <div className="col-5">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_company_type")}
            </div>
            <div className="font-16">{companyTypeLabel}</div>
          </div>
        </div>
        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_company_legal_province")}
            </div>
            <div className="font-16">{legalContractor.companyLegalProvince.value}</div>
          </div>
          <div className="col-5">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_company_legal_city")}
            </div>
            <div className="font-16">{legalContractor.companyLegalCity.value}</div>
          </div>
        </div>
        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_company_legal_address")}
            </div>
            <div className="font-16">{legalContractor.companyLegalAddress}</div>
          </div>
          <div className="col-5">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_company_legal_cap")}
            </div>
            <div className="font-16">{legalContractor.companyLegalCap.value}</div>
          </div>
        </div>
        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t(`data_entry_step_4.insured_company_fc`)}
            </div>
            <div className="font-16">{legalContractor.companyFC}</div>
          </div>
          {legalContractor.companyFCNotMatchVAT && legalContractor.companyFC && (
            <div className="col-5">
              <div className="font-12-light c-7f7f7f">
                {t("data_entry_step_4.insured_company_vat")}
              </div>
              <div className="font-16">{legalContractor.companyVAT}</div>
            </div>
          )}
        </div>
        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_company_legal_phone")}
            </div>
            <div className="font-16">
              {legalContractor.companyPhone?.formattedPhone
                ? legalContractor.companyPhone?.formattedPhone
                : "-"}
            </div>
          </div>
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.email")}
            </div>
            <div className="font-16">{legalContractor.companyEmail}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
